import React, { Component } from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'

import history from 'utils/appHistory'
import { t } from 'translation'

import HistoryModalListItem from './HistoryModalListItem'

import { setPlayerInfo, endPlaylistPlay, setPainLevelBefore } from 'store/actions'
import { ANXIETY, PAIN } from 'utils/constants'

const HistoryModalList = ({
  allSongsMap,
  setPlayerInfo,
  endPlaylistPlay,
  historyList,
  setPainLevelBefore,
}) => {
  const launchSongFromHistory = (historyEntry) => {
    setPlayerInfo(historyEntry)
    endPlaylistPlay()
    if (historyEntry.indicationType === PAIN || historyEntry.indicationType === ANXIETY)
      setPainLevelBefore(1)

    history.push('/player')
  }

  const filteredHistoryList = historyList
    // Only show songs when loaded data available from backend
    // Also, will not show songs that have since been deleted by an admin
    .filter(({ songId }) => allSongsMap[songId])

  return (
    <div className="popup_in right_pos_mod">
      {filteredHistoryList.length ? (
        <div className="popup_list_w">
          <h1 className="section_title popup_list_heading">
            {t('history.LISTENING_HISTORY')} ({filteredHistoryList.length})
          </h1>
          <ul className="popup_list" onClick={(e) => e.stopPropagation()}>
            {filteredHistoryList.map((historyItem) => {
              const songInfo = allSongsMap[historyItem.songId]
              const { title, genreName, artist } = songInfo

              return (
                <HistoryModalListItem
                  {...{ title, genreName, artist }}
                  {...historyItem}
                  key={historyItem.time}
                  launchSongFromHistory={() => launchSongFromHistory(historyItem)}
                />
              )
            })}
          </ul>
        </div>
      ) : (
        <div className="popup_list_no_history">
          {t('history.LISTENING_HISTORY_EMPTY')}
        </div>
      )}
    </div>
  )
}

const mapStateToProps = ({ history: { historyList }, player: { allSongsMap } }) => ({
  historyList,
  allSongsMap,
})

const willMapDispatchToProps = { setPlayerInfo, endPlaylistPlay, setPainLevelBefore }

export default connect(mapStateToProps, willMapDispatchToProps)(HistoryModalList)

HistoryModalList.propTypes = {
  historyList: PropTypes.array.isRequired,
  allSongsMap: PropTypes.object.isRequired,
  setPlayerInfo: PropTypes.func.isRequired,
  endPlaylistPlay: PropTypes.func.isRequired,
}
